import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromSubscriptionPlans from '../reducers/subscription-plans.reducers';
export const selectSubscriptionPlansState = createFeatureSelector<fromSubscriptionPlans.State>('subscriptionPlans');
export const selectSubscriptionPlans = createSelector(
    selectSubscriptionPlansState,
    (state: fromSubscriptionPlans.State) => state.plans
);
export const selectSubscriptionPlansErrorMessage = createSelector(
    selectSubscriptionPlansState,
    (state: fromSubscriptionPlans.State) => state.errorMessage
);
export const selectIsSubscriptionPlansLoading = createSelector(
    selectSubscriptionPlansState,
    (state: fromSubscriptionPlans.State) => state.isLoading
);

export const selectUserActiveSubscriptions = createSelector(
    selectSubscriptionPlansState,
    (state: fromSubscriptionPlans.State) => state.userActiveSubscriptions
);

export const selectIsUserSubscriptionsLoading = createSelector(
    selectSubscriptionPlansState,
    (state: fromSubscriptionPlans.State) => state.isLoadingUserSubscriptions
);